import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const registroImporterSelectors = importerSelectors(
  'registro.importer',
);

export default registroImporterSelectors;
